import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import AdminLogin from './pages/adminLogin';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/login' element={<AdminLogin />} />
        <Route path='/:topicPath' element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
